import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products/attributes/brands'

const ProductAttributeBrandsApiV2 = {
  /**
   * Get list of `Product Brand`
   * @param {object} params uri parameter
   * @return {object} Collection of `Filtered Brand`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params   = QueryParamsUtil.format(tableState, additionalFilters)
    const path     = API_PATH
    const response = axios.get(path, { params })
    return response
  },
  /**
   * Create new brand options
   * @param {string} label brand label
   * @param {string} url optional brand url
   */
  create: async (payload) => {
    const brand    = {  brand: payload }
    const response = axios.post(API_PATH, brand)
    return response
  },
  /**
   * Rename existing brand options
   * @param {string} id brand id
   * @param {string} label brand label
   * @param {string} url optional brand url
   */
  update: async (id, payload) => {
    const endpoint = `${API_PATH}/${id}`
    const brand    = {  brand: payload }
    const response = axios.patch(endpoint, brand)
    return response
  },

  /**
   * Enable a particular Product Brand
   * @param {number} id - id of the Product Brand
   */
  enable: async (id) => {
    const path = `${API_PATH}/${id}/enable`

    const response = axios.patch(path)
    return response
  },

  /**
   * Disable a particular Product Brand
   * @param {number} id - id of the Product Brand
   */
  disable: async (id) => {
    const path = `${API_PATH}/${id}/disable`

    const response = axios.patch(path)
    return response
  }
}

export default ProductAttributeBrandsApiV2
